import { useInView } from 'react-intersection-observer';
import React, { useEffect } from 'react';
import { NavigationCarousel } from '@/features/carousel';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { HOMEPAGE_VIDEO_SLUG } from '@/app/(home-page)/contants';
import useGetVideos from '@/app/videos/utils/use-get-videos';
import { cn } from '@/utils/cn';
import { getCdnUrl } from '@/utils/url';
import SingleVideoItem from '../single-video-item';
interface Props {
  slug?: string;
  productSlug?: string;
  componentMeta?: {
    componentId: string;
    sortKey: string;
  };
  withInfiniteLoading: boolean;
  isBlack: boolean;
}
const patternImage = getCdnUrl('/_toad/images/video-bg-pattern.png');
const CarouselContent = ({
  slug,
  productSlug,
  componentMeta,
  withInfiniteLoading,
  isBlack
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    ref: lastVideoRef,
    inView: isLastItemInView
  } = useInView();
  const {
    videos,
    fetchNextPage,
    isFetchingNextPage,
    isFetching,
    hasNextPage
  } = useGetVideos({
    slug,
    productSlug
  });
  useEffect(() => {
    if (isLastItemInView && !isFetchingNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [fetchNextPage, isLastItemInView, isFetchingNextPage, isFetching]);
  const isLanding = !!slug && slug !== HOMEPAGE_VIDEO_SLUG;
  const showSingleView = isLanding && videos?.length === 1;
  if (showSingleView) {
    const video = videos?.[0];
    if (!video || !video.slug) return null;
    const patternStyle = {
      backgroundImage: `url(${patternImage})`
    };
    return <div className={cn('relative flex w-full items-center justify-center rounded py-2 lg:rounded-lg', !isBlack && 'bg-surface-solid-50')}>
                <div className='relative'>
                    <span className='absolute bottom-0 left-full h-35 w-20 bg-contain lg:h-64 lg:w-33' style={patternStyle} />
                    <span className='absolute right-full top-0 h-35 w-20 rotate-180 bg-contain lg:h-64 lg:w-33' style={patternStyle} />

                    <SingleVideoItem key={video.slug} slug={video.slug} componentId={componentMeta?.componentId} sortKey={componentMeta?.sortKey} index={0} cover={video.cover || ''} title={video.title || ''} isSingle />
                </div>
            </div>;
  }
  return <NavigationCarousel options={{
    perView: 'auto',
    mode: 'free-snap',
    spacing: isMobile ? 8 : 16
  }} data-sentry-element="NavigationCarousel" data-sentry-component="CarouselContent" data-sentry-source-file="content.tsx">
            {videos?.map(({
      cover = '',
      slug,
      title
    }, index) => {
      if (!slug) return null;
      const isAddingRef = withInfiniteLoading && hasNextPage && index === videos.length - 1;
      const itemRef = isAddingRef ? lastVideoRef : undefined;
      return <SingleVideoItem key={slug} slug={slug} componentId={componentMeta?.componentId} sortKey={componentMeta?.sortKey} index={index} cover={cover} title={title || ''} inViewRef={itemRef} />;
    })}
            {isFetchingNextPage && <div className='keen-slider__slide !h-[150px] !min-w-[90px] !max-w-[90px] shrink-0 animate-pulse rounded bg-gray-100 lg:!h-[292px] lg:!min-w-44 lg:!max-w-44' />}
        </NavigationCarousel>;
};
export default CarouselContent;